import React from 'react';
import {isPRD} from '../../../utlis/vars';
import {Text, Title} from '../@Text';
import {FmComponent} from '../types/types';
import './style.scss';

interface IHighlightSelector extends FmComponent {
  title: string;
  subtitle?: string;
  text: string;
  selected?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  titleStyle?: React.CSSProperties;
  subtitleStyle?: React.CSSProperties;
  textStyle?: React.CSSProperties;
}

const HighlightSelector = ({
                             title,
                             subtitle,
                             text,
                             selected = false,
                             onClick,
                             style,
                             titleStyle,
                             subtitleStyle,
                             textStyle,
                             id,
                             className,
                             'data-testid': dataTestId
                           }: IHighlightSelector): React.ReactElement => {
    return (
        <div
            data-testid={isPRD ? undefined : dataTestId}
            id={id}
            className={`fm-highlight-selector${selected ? ' fm-hs-selected' : ''}${className ? ` ${className}` : ''}`}
            onClick={onClick}
            style={style}
        >
            <Title weight="semibold" style={titleStyle} className="fm-hs-title">
                {title}
            </Title>

            { subtitle &&
                <Text color="black" style={subtitleStyle}>
                    {subtitle}
                </Text>
            }

            <Text color="gray" style={textStyle}>
                {text}
            </Text>
        </div>
    );
};

export default HighlightSelector;
